import SectionHeading from "./SectionHeading";
import { responseItems } from "@/mocks/siteData";

const avatarTones = ["bg-primary-500", "bg-accent-500", "bg-secondary-500", "bg-foreground-800"];

export default function Responses() {
  return (
    <section id="responses" className="scroll-mt-20 bg-background-50">
      <div className="mx-auto w-full max-w-7xl px-4 py-16 md:px-6 md:py-24">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-[0.9fr_1.6fr]">
          <div className="lg:sticky lg:top-24 lg:self-start">
            <SectionHeading
              kicker="Party Responses"
              title="各方回应 · 公说公有理"
              subtitle="当事人、供应商、平台与第三方机构先后发声。把它们放一起看，冲突点与共识点一目了然。"
            />
            <div className="mt-6 rounded-2xl border border-accent-200 bg-accent-100/50 p-5">
              <p className="text-sm font-bold text-accent-900">小提示</p>
              <p className="mt-2 text-[13px] leading-relaxed text-accent-900/80">
                各方回应往往措辞谨慎。建议先读「完整时间线」，再回看本板块，更容易分辨哪句是实质承诺、哪句只是公关口径。
              </p>
            </div>
          </div>

          <div className="grid grid-cols-1 gap-5 md:grid-cols-2">
            {responseItems.map((item, idx) => (
              <article key={item.id} className="flex flex-col rounded-2xl border border-background-200 bg-background-100 p-5 transition-all duration-300 hover:-translate-y-1 hover:bg-background-50 hover:shadow-lift">
                <div className="flex items-center gap-3">
                  <span
                    className={`inline-flex h-11 w-11 shrink-0 items-center justify-center rounded-xl font-heading text-base font-black text-background-50 ${
                      avatarTones[idx % avatarTones.length]
                    }`}
                  >
                    {item.party.charAt(0)}
                  </span>
                  <div className="min-w-0">
                    <h3 className="truncate font-heading text-[15px] font-bold text-foreground-950">{item.party}</h3>
                    <p className="text-xs text-foreground-500">
                      {item.role} · {item.timeLabel}
                    </p>
                  </div>
                </div>

                <span className="mt-4 inline-flex w-max items-center gap-1.5 rounded-full border border-background-200 bg-background-50 px-3 py-1 text-xs font-bold text-foreground-800">
                  <i className="ri-question-answer-line text-primary-500" />
                  立场：{item.stance}
                </span>

                <blockquote className="relative mt-3 flex-1 text-sm leading-relaxed text-foreground-700">
                  <i className="ri-double-quotes-l absolute -left-1 -top-2 text-2xl text-accent-400/50" aria-hidden="true" />
                  <span className="pl-5">{item.quote}</span>
                </blockquote>

                <div className="mt-4 flex items-center justify-between border-t border-background-200 pt-3">
                  <span className="inline-flex items-center gap-1.5 text-xs font-medium text-secondary-700">
                    <i className="ri-check-double-line" />
                    跟进动作
                  </span>
                  <span className="rounded-md bg-secondary-100 px-2.5 py-1 text-[11px] font-semibold text-secondary-800">
                    {item.action}
                  </span>
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}